module.exports = __webpack_public_path__ + "static/media/about.0d040853.png";